export const LIST = "EVENT_MATCH_LIST";
export const OPTION_DATA = "EVENT_MATCH_OPTION_DATA";
export const CREATE = "EVENT_MATCH_CREATE";
export const UPDATE = "EVENT_MATCH_UPDATE";
export const UPDATE_STATUS = "EVENT_MATCH_UPDATE_STATUS";
export const UPDATE_SCORE = "EVENT_MATCH_UPDATE_SCORE";